import script from "./front_page.vue?vue&type=script&setup=true&lang=js"
export * from "./front_page.vue?vue&type=script&setup=true&lang=js"

import "./front_page.vue?vue&type=style&index=0&id=1da4483e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da4483e"]])

export default __exports__